<template>
  <h3 class="checkout-overlay-title"><slot /></h3>
</template>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .side-right .checkout-overlay-title {
    margin-top: 0;
  }

  .checkout-overlay-title {
    .full & {
      font-size: 28px;
      font-weight: normal;
      margin-top: 4px;
      display: inline-block;
      color: #fff;
    }

    .platform & {
      padding: 20px;
      margin: 0;
      background: #fff;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
      font-size: 18px;
      font-weight: normal;
      border-bottom: 1px solid rgba(#000, .1);
    }
  }
</style>

<script>
  export default {
    name: 'checkout-overlay-title'
  }
</script>
